'use strict';

Object.defineProperty(exports, "__esModule", {
	value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _materialUi = require('material-ui');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var BulkCreateForm = function (_React$Component) {
	_inherits(BulkCreateForm, _React$Component);

	function BulkCreateForm(props) {
		_classCallCheck(this, BulkCreateForm);

		var _this = _possibleConstructorReturn(this, (BulkCreateForm.__proto__ || Object.getPrototypeOf(BulkCreateForm)).call(this, props));

		_this.state = {
			questionsText: ''
		};

		_this.onClickSubmit = _this.onClickSubmit.bind(_this);
		_this.onChangeField = _this.onChangeField.bind(_this);
		return _this;
	}

	_createClass(BulkCreateForm, [{
		key: 'onClickSubmit',
		value: function onClickSubmit() {
			this.props.submit(this.state.questionsText);
		}
	}, {
		key: 'onChangeField',
		value: function onChangeField(field) {
			var _this2 = this;

			return function (event, value) {
				_this2.setState(_defineProperty({}, field, value));
			};
		}
	}, {
		key: 'render',
		value: function render() {
			return _react2.default.createElement(
				_materialUi.Paper,
				{ style: { padding: '0 1rem 1rem 1rem' } },
				_react2.default.createElement(_materialUi.TextField, {
					multiLine: true,
					rows: 25,
					rowsMax: 25,
					floatingLabelText: 'Quest\xF5es',
					floatingLabelFixed: true,
					onChange: this.onChangeField('questionsText'),
					value: this.state.questionsText,
					errorText: '',
					fullWidth: true
				}),
				_react2.default.createElement(_materialUi.RaisedButton, { label: 'Cancelar', onClick: this.props.onCancel }),
				_react2.default.createElement(_materialUi.RaisedButton, {
					primary: true, label: 'Enviar',
					onClick: this.onClickSubmit,
					style: { margin: '1rem' }
				})
			);
		}
	}]);

	return BulkCreateForm;
}(_react2.default.Component);

exports.default = BulkCreateForm;
//# sourceMappingURL=data:application/json;charset=utf-8;base64,eyJ2ZXJzaW9uIjozLCJzb3VyY2VzIjpbInNyYy9jbGllbnQvY29tcG9uZW50cy9xdWVzdGlvbnMvQnVsa0NyZWF0ZUZvcm0uanMiXSwibmFtZXMiOlsiQnVsa0NyZWF0ZUZvcm0iLCJwcm9wcyIsInN0YXRlIiwicXVlc3Rpb25zVGV4dCIsIm9uQ2xpY2tTdWJtaXQiLCJiaW5kIiwib25DaGFuZ2VGaWVsZCIsInN1Ym1pdCIsImZpZWxkIiwiZXZlbnQiLCJ2YWx1ZSIsInNldFN0YXRlIiwicGFkZGluZyIsIm9uQ2FuY2VsIiwibWFyZ2luIiwiUmVhY3QiLCJDb21wb25lbnQiXSwibWFwcGluZ3MiOiI7Ozs7Ozs7O0FBQUE7Ozs7QUFDQTs7Ozs7Ozs7Ozs7O0lBRXFCQSxjOzs7QUFFcEIseUJBQVlDLEtBQVosRUFBbUI7QUFBQTs7QUFBQSw4SEFDWkEsS0FEWTs7QUFHbEIsUUFBS0MsS0FBTCxHQUFhO0FBQ1pDLGtCQUFlO0FBREgsR0FBYjs7QUFJQSxRQUFLQyxhQUFMLEdBQXFCLE1BQUtBLGFBQUwsQ0FBbUJDLElBQW5CLE9BQXJCO0FBQ0EsUUFBS0MsYUFBTCxHQUFxQixNQUFLQSxhQUFMLENBQW1CRCxJQUFuQixPQUFyQjtBQVJrQjtBQVNsQjs7OztrQ0FFZTtBQUNmLFFBQUtKLEtBQUwsQ0FBV00sTUFBWCxDQUFrQixLQUFLTCxLQUFMLENBQVdDLGFBQTdCO0FBQ0E7OztnQ0FFYUssSyxFQUFPO0FBQUE7O0FBQ3BCLFVBQU8sVUFBQ0MsS0FBRCxFQUFRQyxLQUFSLEVBQWtCO0FBQ3hCLFdBQUtDLFFBQUwscUJBQ0VILEtBREYsRUFDVUUsS0FEVjtBQUdBLElBSkQ7QUFLQTs7OzJCQUVRO0FBQ1IsVUFDQztBQUFDLHFCQUFEO0FBQUEsTUFBTyxPQUFPLEVBQUVFLFNBQVMsa0JBQVgsRUFBZDtBQUNDLGtDQUFDLHFCQUFEO0FBQ0Msb0JBREQ7QUFFQyxXQUFNLEVBRlA7QUFHQyxjQUFTLEVBSFY7QUFJQyx3QkFBa0IsYUFKbkI7QUFLQyw2QkFMRDtBQU1DLGVBQVUsS0FBS04sYUFBTCxDQUFtQixlQUFuQixDQU5YO0FBT0MsWUFBTyxLQUFLSixLQUFMLENBQVdDLGFBUG5CO0FBUUMsZ0JBQVcsRUFSWjtBQVNDO0FBVEQsTUFERDtBQVlDLGtDQUFDLHdCQUFELElBQWMsT0FBTSxVQUFwQixFQUErQixTQUFTLEtBQUtGLEtBQUwsQ0FBV1ksUUFBbkQsR0FaRDtBQWFhLGtDQUFDLHdCQUFEO0FBQ0ksa0JBREosRUFDWSxPQUFNLFFBRGxCO0FBRUksY0FBUyxLQUFLVCxhQUZsQjtBQUdJLFlBQU8sRUFBRVUsUUFBUSxNQUFWO0FBSFg7QUFiYixJQUREO0FBcUJBOzs7O0VBL0MwQ0MsZ0JBQU1DLFM7O2tCQUE3QmhCLGMiLCJmaWxlIjoiQnVsa0NyZWF0ZUZvcm0uanMiLCJzb3VyY2VSb290IjoiL3NyYyIsInNvdXJjZXNDb250ZW50IjpbImltcG9ydCBSZWFjdCBmcm9tICdyZWFjdCc7XG5pbXBvcnQgeyBQYXBlciwgVGV4dEZpZWxkLCBSYWlzZWRCdXR0b24gfSBmcm9tICdtYXRlcmlhbC11aSc7XG5cbmV4cG9ydCBkZWZhdWx0IGNsYXNzIEJ1bGtDcmVhdGVGb3JtIGV4dGVuZHMgUmVhY3QuQ29tcG9uZW50IHtcblxuXHRjb25zdHJ1Y3Rvcihwcm9wcykge1xuXHRcdHN1cGVyKHByb3BzKTtcblx0XHRcblx0XHR0aGlzLnN0YXRlID0ge1xuXHRcdFx0cXVlc3Rpb25zVGV4dDogJydcblx0XHR9O1xuXG5cdFx0dGhpcy5vbkNsaWNrU3VibWl0ID0gdGhpcy5vbkNsaWNrU3VibWl0LmJpbmQodGhpcyk7XG5cdFx0dGhpcy5vbkNoYW5nZUZpZWxkID0gdGhpcy5vbkNoYW5nZUZpZWxkLmJpbmQodGhpcyk7XG5cdH1cblxuXHRvbkNsaWNrU3VibWl0KCkge1xuXHRcdHRoaXMucHJvcHMuc3VibWl0KHRoaXMuc3RhdGUucXVlc3Rpb25zVGV4dCk7XG5cdH1cblxuXHRvbkNoYW5nZUZpZWxkKGZpZWxkKSB7XG5cdFx0cmV0dXJuIChldmVudCwgdmFsdWUpID0+IHtcblx0XHRcdHRoaXMuc2V0U3RhdGUoe1xuXHRcdFx0XHRbZmllbGRdOiB2YWx1ZVxuXHRcdFx0fSk7XG5cdFx0fTtcblx0fVxuXG5cdHJlbmRlcigpIHtcblx0XHRyZXR1cm4gKFxuXHRcdFx0PFBhcGVyIHN0eWxlPXt7IHBhZGRpbmc6ICcwIDFyZW0gMXJlbSAxcmVtJyB9fT5cblx0XHRcdFx0PFRleHRGaWVsZFxuXHRcdFx0XHRcdG11bHRpTGluZVxuXHRcdFx0XHRcdHJvd3M9ezI1fVxuXHRcdFx0XHRcdHJvd3NNYXg9ezI1fVxuXHRcdFx0XHRcdGZsb2F0aW5nTGFiZWxUZXh0PVwiUXVlc3TDtWVzXCJcblx0XHRcdFx0XHRmbG9hdGluZ0xhYmVsRml4ZWRcblx0XHRcdFx0XHRvbkNoYW5nZT17dGhpcy5vbkNoYW5nZUZpZWxkKCdxdWVzdGlvbnNUZXh0Jyl9XG5cdFx0XHRcdFx0dmFsdWU9e3RoaXMuc3RhdGUucXVlc3Rpb25zVGV4dH1cblx0XHRcdFx0XHRlcnJvclRleHQ9eycnfVxuXHRcdFx0XHRcdGZ1bGxXaWR0aFxuXHRcdFx0XHQvPlxuXHRcdFx0XHQ8UmFpc2VkQnV0dG9uIGxhYmVsPVwiQ2FuY2VsYXJcIiBvbkNsaWNrPXt0aGlzLnByb3BzLm9uQ2FuY2VsfSAvPlxuICAgICAgICAgICAgICAgIDxSYWlzZWRCdXR0b24gXG4gICAgICAgICAgICAgICAgICAgIHByaW1hcnkgbGFiZWw9XCJFbnZpYXJcIlxuICAgICAgICAgICAgICAgICAgICBvbkNsaWNrPXt0aGlzLm9uQ2xpY2tTdWJtaXR9XG4gICAgICAgICAgICAgICAgICAgIHN0eWxlPXt7IG1hcmdpbjogJzFyZW0nIH19XG4gICAgICAgICAgICAgICAgLz5cblx0XHRcdDwvUGFwZXI+XG5cdFx0KTtcblx0fVxufVxuIl19


//////////////////
// WEBPACK FOOTER
// ./src/client/components/questions/BulkCreateForm.js
// module id = 2558
// module chunks = 0